const breakpoints = {
  mobile: '0px',
  xm: '373px',
  xms: '400px',
  xxm: '544px',
  tablet: '656px',
  safariXt: '730px',
  xt: '740px',
  md: '768px',
  mg: '885px',
  lg: '960px',
  laptop: '992px',
  xl: '1024px',
  xxl: '1200px',
  xxls: '1250px',
  xxxl: '1330px',
  preDesktop: '1439px',
  desktop: '1441px',
  xds: '1550px',
  xd: '1700px',
  xxd: '1900px',
};

export default breakpoints;
